// extracted by mini-css-extract-plugin
export var accordionButton = "AccordionItem-module--accordionButton--df75a";
export var accordionItem = "AccordionItem-module--accordionItem--5d3fe";
export var accordionPanel = "AccordionItem-module--accordionPanel--ab991";
export var active = "AccordionItem-module--active--8e967";
export var answer = "AccordionItem-module--answer--bbef3";